import React from "react";

const EmptyDataIcon: React.FC = () => (
    <svg
      width="107"
      height="87"
      viewBox="0 0 107 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="54.1878" cy="38.1096" r="38.0686" fill="#EAECF0" />
      <circle cx="14.217" cy="9.55845" r="3.80686" fill="#F2F4F7" />
      <circle cx="96.0641" cy="59.9991" r="2.85515" fill="#F2F4F7" />
      <circle cx="13.741" cy="65.7096" r="4.75858" fill="#F2F4F7" />
      <circle cx="101.774" cy="18.1238" r="4.75858" fill="#F2F4F7" />
      <circle cx="92.7334" cy="5.27571" r="3.33101" fill="#F2F4F7" />
      <g filter="url(#filter0_dd_2292_54531)">
        <path
          d="M28.5303 59.1494L53.4897 47.5107C54.7428 46.9263 55.285 45.4367 54.7007 44.1836L39.9607 12.5736L29.9794 8.94069L9.55809 18.4633C8.30494 19.0476 7.76278 20.5372 8.34713 21.7904L25.2032 57.9384C25.7876 59.1916 27.2772 59.7337 28.5303 59.1494Z"
          fill="url(#paint0_linear_2292_54531)"
        />
        <path
          d="M29.9805 8.94067L39.9618 12.5736L33.1547 15.7478L29.9805 8.94067Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter1_dd_2292_54531)">
        <path
          d="M40.4606 50.6437H68.0002C69.3829 50.6437 70.5038 49.5228 70.5038 48.1401V13.2624L62.993 5.75159H40.4606C39.0779 5.75159 37.957 6.87249 37.957 8.25519V48.1401C37.957 49.5228 39.0779 50.6437 40.4606 50.6437Z"
          fill="url(#paint1_linear_2292_54531)"
        />
        <path
          d="M62.9941 5.75159L70.5049 13.2624H62.9941V5.75159Z"
          fill="#D0D5DD"
        />
      </g>
      <g filter="url(#filter2_dd_2292_54531)">
        <path
          d="M54.623 47.4958L79.5823 59.1345C80.8355 59.7188 82.3251 59.1767 82.9094 57.9235L97.6494 26.3136L94.0165 16.3323L73.5952 6.80965C72.3421 6.2253 70.8525 6.76747 70.2681 8.02062L53.412 44.1687C52.8276 45.4218 53.3698 46.9114 54.623 47.4958Z"
          fill="url(#paint2_linear_2292_54531)"
        />
        <path
          d="M94.0176 16.3322L97.6505 26.3135L90.8434 23.1393L94.0176 16.3322Z"
          fill="#D0D5DD"
        />
      </g>
      <rect
        x="40.8633"
        y="41.9165"
        width="26.648"
        height="26.648"
        rx="13.324"
        fill="url(#paint3_linear_2292_54531)"
      />
      <g clipPath="url(#clip0_2292_54531)">
        <path
          d="M56.4086 57.4611L54.1879 55.2404M54.1879 55.2404L51.9673 57.4611M54.1879 55.2404V60.2369M58.8458 58.7879C59.3873 58.4927 59.815 58.0256 60.0615 57.4603C60.308 56.895 60.3593 56.2637 60.2072 55.666C60.055 55.0684 59.7082 54.5384 59.2214 54.1597C58.7347 53.7811 58.1356 53.5753 57.5189 53.5749H56.8194C56.6514 52.9249 56.3382 52.3215 55.9034 51.81C55.4686 51.2985 54.9234 50.8922 54.309 50.6217C53.6946 50.3512 53.0268 50.2235 52.3559 50.2483C51.6851 50.273 51.0285 50.4495 50.4356 50.7644C49.8428 51.0794 49.3291 51.5247 48.9331 52.0668C48.5371 52.6089 48.2691 53.2338 48.1494 53.8943C48.0296 54.5549 48.0612 55.234 48.2416 55.8806C48.4221 56.5273 48.7469 57.1245 49.1914 57.6276"
          stroke="white"
          strokeWidth="1.11034"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g clipPath="url(#clip1_2292_54531)">
        <path
          d="M90.097 22.5079H28.8486C28.0223 22.5084 27.23 22.8369 26.6457 23.4212C26.0614 24.0055 25.7329 24.7978 25.7324 25.6241V81.8201C25.7329 82.6464 26.0614 83.4387 26.6457 84.023C27.23 84.6073 28.0223 84.9358 28.8486 84.9363H90.097C90.9234 84.9359 91.7158 84.6074 92.3001 84.0231C92.8845 83.4388 93.213 82.6465 93.2135 81.8201V25.6241C93.213 24.7978 92.8845 24.0054 92.3001 23.4211C91.7158 22.8368 90.9234 22.5084 90.097 22.5079Z"
          fill="#C6C6C6"
        />
        <path
          d="M86.0655 65.4085H32.8818C31.1609 65.4085 29.7656 64.0132 29.7656 62.2923V12.6403C29.7656 10.9193 31.1609 9.52405 32.8818 9.52405H86.0655C87.7865 9.52405 89.1817 10.9193 89.1817 12.6403V62.2923C89.1817 64.0132 87.7865 65.4085 86.0655 65.4085Z"
          fill="#F9F9F9"
        />
        <path
          d="M30.7522 63.2786V13.6269C30.7522 11.9059 32.1475 10.5107 33.8684 10.5107H87.0521C87.66 10.5107 88.2251 10.6873 88.7042 10.9882C88.1533 10.1097 87.1789 9.52405 86.0655 9.52405H32.8818C31.1609 9.52405 29.7656 10.9193 29.7656 12.6403V62.2923C29.7656 63.406 30.3513 64.3801 31.2298 64.9313C30.9289 64.4518 30.7522 63.8868 30.7522 63.2789V63.2786Z"
          fill="url(#paint4_linear_2292_54531)"
        />
        <path
          d="M79.5217 20.0146H39.4258V22.2997H79.5217V20.0146ZM79.5217 28.7396H39.4258V31.0247H79.5217V28.7396ZM79.5217 37.4666H39.4258V39.7516H79.5217V37.4666ZM79.5217 46.1916H39.4258V48.4769H79.5217V46.1916Z"
          fill="white"
        />
        <path
          d="M44.2031 38.8162L54.2787 48.892H44.2031V38.8162Z"
          fill="url(#paint5_linear_2292_54531)"
        />
        <path
          d="M93.214 49.7233V26.5406L89.1816 22.5079V49.7229H93.214V49.7233Z"
          fill="#C6C6C6"
        />
        <path
          d="M97.9365 51.8202L93.592 82.5742C93.3748 84.1117 92.059 85.2544 90.5064 85.2544H28.439C26.8864 85.2544 25.5706 84.1117 25.3534 82.5742L19.4824 41.018C19.2175 39.142 20.6733 37.4658 22.568 37.4658H41.7357C43.2883 37.4658 44.6041 38.6085 44.8213 40.1457L45.5907 45.5878C45.8079 47.1253 47.1237 48.268 48.6764 48.268H94.8515C96.7455 48.268 98.2016 49.9442 97.9368 51.8202H97.9365Z"
          fill="url(#paint6_linear_2292_54531)"
        />
        <path
          d="M82.5442 71.5366H36.4032C36.1503 71.5365 35.9061 71.4442 35.7163 71.277C35.5266 71.1098 35.4043 70.8791 35.3725 70.6282L34.7952 66.0575C34.7769 65.9113 34.7898 65.7629 34.8332 65.622C34.8766 65.4812 34.9495 65.3512 35.0469 65.2407C35.1444 65.1302 35.2643 65.0416 35.3986 64.981C35.5329 64.9203 35.6785 64.8889 35.8259 64.8888H83.1215C83.2688 64.8889 83.4145 64.9203 83.5488 64.981C83.6831 65.0416 83.803 65.1302 83.9004 65.2407C83.9979 65.3512 84.0707 65.4812 84.1142 65.622C84.1576 65.7629 84.1705 65.9113 84.1522 66.0575L83.5749 70.6282C83.543 70.8791 83.4208 71.1098 83.231 71.277C83.0413 71.4442 82.7971 71.5365 82.5442 71.5366Z"
          fill="#D5D5D5"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_2292_54531"
          x="-2.2281"
          y="5.76648"
          width="67.5031"
          height="73.4754"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.90343"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2292_54531"
          />
          <feOffset dy="3.80686" />
          <feGaussianBlur stdDeviation="1.90343" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2292_54531"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.90343"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_2292_54531"
          />
          <feOffset dy="9.51716" />
          <feGaussianBlur stdDeviation="5.7103" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2292_54531"
            result="effect2_dropShadow_2292_54531"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2292_54531"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_2292_54531"
          x="28.4399"
          y="5.75159"
          width="51.5831"
          height="63.9264"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.90343"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2292_54531"
          />
          <feOffset dy="3.80686" />
          <feGaussianBlur stdDeviation="1.90343" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2292_54531"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.90343"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_2292_54531"
          />
          <feOffset dy="9.51716" />
          <feGaussianBlur stdDeviation="5.7103" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2292_54531"
            result="effect2_dropShadow_2292_54531"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2292_54531"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_2292_54531"
          x="42.8364"
          y="5.75159"
          width="67.505"
          height="73.4752"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.90343"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_2292_54531"
          />
          <feOffset dy="3.80686" />
          <feGaussianBlur stdDeviation="1.90343" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2292_54531"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.90343"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_2292_54531"
          />
          <feOffset dy="9.51716" />
          <feGaussianBlur stdDeviation="5.7103" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_2292_54531"
            result="effect2_dropShadow_2292_54531"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2292_54531"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2292_54531"
          x1="27.064"
          y1="59.2468"
          x2="7.17333"
          y2="23.3626"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E7EC" />
          <stop offset="1" stopColor="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2292_54531"
          x1="39.0905"
          y1="50.1123"
          x2="36.2288"
          y2="9.18401"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E7EC" />
          <stop offset="1" stopColor="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2292_54531"
          x1="53.6058"
          y1="46.4351"
          x2="68.3092"
          y2="8.13203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E7EC" />
          <stop offset="1" stopColor="#F9FAFB" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2292_54531"
          x1="54.1873"
          y1="28.5925"
          x2="27.5393"
          y2="55.2405"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8960" />
          <stop offset="1" stopColor="#FF62A5" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2292_54531"
          x1="61.301"
          y1="39.2902"
          x2="21.8914"
          y2="-0.119654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2292_54531"
          x1="50.86"
          y1="50.5087"
          x2="38.6812"
          y2="38.3303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C2CECE" stopOpacity="0" />
          <stop offset="0.179" stopColor="#AFBCBC" stopOpacity="0.179" />
          <stop offset="1" stopColor="#5B6A6A" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2292_54531"
          x1="58.7094"
          y1="37.4658"
          x2="58.7094"
          y2="85.2544"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF0F4" />
          <stop offset="0.927" stopColor="#E4E4E4" />
        </linearGradient>
        <clipPath id="clip0_2292_54531">
          <rect
            width="13.324"
            height="13.324"
            fill="white"
            transform="translate(47.5254 48.5785)"
          />
        </clipPath>
        <clipPath id="clip1_2292_54531">
          <rect
            width="78.5165"
            height="78.5165"
            fill="white"
            transform="translate(19.4512 8.13062)"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default EmptyDataIcon;
